// ABOUTME: System fields node-info can show besides content types: creation/update dates, last editor, last update.
// ABOUTME: A content type defined in the schema with the same code always takes precedence.

export type NodeInfoSystemField = 'updatedAt' | 'createdAt' | 'updatedBy' | 'lastUpdate';

const SYSTEM_FIELDS: ReadonlySet<string> = new Set([
    'updatedAt',
    'createdAt',
    'updatedBy',
    'lastUpdate',
]);

export interface NodeSystemData {
    createdAt?: number | null;
    updatedAt?: number | null;
    updatedBy?: string | null;
}

export function isNodeInfoSystemField(
    code: string,
    schemaTypes: Record<string, string>,
): code is NodeInfoSystemField {
    return SYSTEM_FIELDS.has(code) && !(code in schemaTypes);
}

// 0 is what a published read model reports for createdAt: not a real date.
const formatTimestamp = (timestamp: number | null | undefined, locale: string): string =>
    timestamp
        ? new Intl.DateTimeFormat(locale, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
          }).format(new Date(timestamp))
        : '';

export function systemFieldLines(
    field: NodeInfoSystemField,
    data: NodeSystemData,
    locale: string,
): string[] {
    const byField: Record<NodeInfoSystemField, string[]> = {
        updatedAt: [formatTimestamp(data.updatedAt, locale)],
        createdAt: [formatTimestamp(data.createdAt, locale)],
        updatedBy: [data.updatedBy ?? ''],
        lastUpdate: [data.updatedBy ?? '', formatTimestamp(data.updatedAt, locale)],
    };
    return byField[field].filter(line => line !== '');
}
